var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStore, createEvent } from "effector";
import { setSurveyEnv, surveyInit } from "./SurveyFillStore";
import { doInit, doConvert, doTrack, doConvertSurvey, formatPhone, doSurveyMatch } from "../util/common-utilities";
export var SiteStoreState;
(function (SiteStoreState) {
    SiteStoreState["INIT"] = "INIT";
    SiteStoreState["QUIZ"] = "QUIZ";
    SiteStoreState["FORM"] = "FORM";
    SiteStoreState["EDUCATE"] = "EDUCATE";
    SiteStoreState["ERROR"] = "ERROR";
    SiteStoreState["POSTING"] = "POSTING";
    SiteStoreState["THANKYOU"] = "THANKYOU";
})(SiteStoreState || (SiteStoreState = {}));
var getBasename = function (path) {
    var bn = path.substr(0, path.lastIndexOf("/"));
    // console.log(bn);
    return bn;
};
export var emptySiteStore = {
    debug: true,
    siteRaw: {},
    site: {},
    env: {},
    platformIdentifiersByKey: {},
    state: SiteStoreState.INIT,
    helpMode: false,
    helpTort: "",
    helpSurveyId: "",
    surveyTarget: "root",
    currentQuestion: undefined,
    currentSurvey: undefined,
    currentSurveyQuestionIndex: 0,
    currentSurveyQuestionCount: 0,
    tqTargets: [],
    tqCount: 0,
    tqIndex: 0,
    questionAnswers: {},
    trackFired: {},
    qualifiesFor: [],
    disqualifiesFor: [],
    formAnswers: {},
    quizNotificationReason: "",
    quizNotificationText: "",
    quizNotificationCallBacks: {},
    convertResult: {},
    strippedUri: getBasename(window.location.pathname),
    geoInfo: {},
    init: false,
    highMeter: 0,
    quickLoadMode: false,
    chatOver: false,
    hidePolicies: false,
};
/// keys to reset if we start over, educate/disqualify
export var resetSiteStore = {
    state: SiteStoreState.INIT,
    helpMode: false,
    helpTort: "",
    surveyTarget: "root",
    currentQuestion: undefined,
    currentSurvey: undefined,
    currentSurveyQuestionIndex: 0,
    currentSurveyQuestionCount: 0,
    tqTargets: [],
    tqCount: 0,
    tqIndex: 0,
    questionAnswers: {},
    qualifiesFor: [],
    disqualifiesFor: [],
    formAnswers: {},
    quizNotificationReason: "",
    quizNotificationText: "",
    quizNotificationCallBacks: {},
    convertResult: {},
    highMeter: 0,
    quickLoadMode: false,
    chatOver: false,
};
export var getMeter = createEvent();
export var ensureFirstQuestionLoaded = createEvent();
export var updateSiteStore = createEvent();
export var processQuestion = createEvent();
export var processForm = createEvent();
export var track = createEvent();
export var convert = createEvent();
export var init = createEvent();
export var convertSurvey = createEvent();
export var matchSurvey = createEvent();
export var extractContentField = function (state, field) {
    var _a, _b, _c, _d;
    var toReturn = {};
    for (var _i = 0, _e = (_b = (_a = state.site.content) === null || _a === void 0 ? void 0 : _a.contentFields) !== null && _b !== void 0 ? _b : []; _i < _e.length; _i++) {
        var cf = _e[_i];
        if (cf.name === field) {
            toReturn = cf;
        }
    }
    /// if here, check for the app default and return that
    if (!toReturn.name) {
        for (var _f = 0, _g = (_d = (_c = state.site.app) === null || _c === void 0 ? void 0 : _c.contentFields) !== null && _d !== void 0 ? _d : []; _f < _g.length; _f++) {
            var cf = _g[_f];
            if (cf.name === field) {
                toReturn = cf;
            }
        }
    }
    /// update color to rgb if it's rgb style
    if (toReturn.type === "COLOR" && toReturn.value) {
        var c = {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0,
        };
        if (toReturn.value[0] === "{") {
            c = JSON.parse(toReturn.value);
            toReturn.value = "rgba(".concat(String(c.r), ",").concat(String(String(c.g)), ",").concat(String(c.b), ",").concat(String(c.a), ")");
        }
    }
    if (toReturn.value) {
        toReturn.value = toReturn.value.replace("%PUBLIC_URL%", state.strippedUri);
    }
    return toReturn;
};
export function configurePlatformIdentifiers(platformIdentifiers) {
    var result = {};
    for (var _i = 0, platformIdentifiers_1 = platformIdentifiers; _i < platformIdentifiers_1.length; _i++) {
        var pi = platformIdentifiers_1[_i];
        if (pi === null) {
            continue;
        }
        if (!(pi === null || pi === void 0 ? void 0 : pi.value)) {
            continue;
        }
        result["".concat(pi === null || pi === void 0 ? void 0 : pi.platform, ":").concat(pi === null || pi === void 0 ? void 0 : pi.name)] = pi;
    }
    return result;
}
var doCalcMeter = function (state) {
    var _a;
    var calc = 0;
    if (state.surveyTarget === "root" && ((_a = state.currentQuestion) === null || _a === void 0 ? void 0 : _a.id)) {
        calc = ((state.currentSurveyQuestionIndex + 1) / (state.currentSurveyQuestionCount + 1)) * 100;
    }
    if (calc > state.highMeter) {
        return calc;
    }
    return state.highMeter;
};
var doEnsureFirstQuestionLoaded = function (state) {
    if (!state.currentQuestion) {
        state.currentSurveyQuestionIndex = 0;
        state.currentQuestion = state.site.survey.questions[state.currentSurveyQuestionIndex];
        state.currentSurveyQuestionCount = state.site.survey.questions.length;
        state.currentSurvey = state.site.survey;
        state.surveyTarget = "root";
        state.highMeter = doCalcMeter(state);
    }
};
export default createStore(emptySiteStore)
    .on(track, function (state, params) {
    if (params.category) {
        state.trackFired[params.category] = true;
    }
    doTrack(state, params);
    return __assign({}, state);
})
    .on(convert, function (state, params) {
    doConvert(state, params);
})
    .on(init, function (state) {
    if (state.site.surveySystemEnable) {
        surveyInit(state);
    }
    doInit(state);
    return __assign({}, state);
})
    .on(matchSurvey, function (state, survey_fill) {
    doSurveyMatch(state, survey_fill);
})
    .on(convertSurvey, function (state, params) {
    doConvertSurvey(state, params);
})
    .on(ensureFirstQuestionLoaded, function (state) {
    doEnsureFirstQuestionLoaded(state);
    // console.log(state);
    return __assign({}, state);
})
    .on(updateSiteStore, function (state, payload) {
    /// piggy back off main APP load to set survey env also
    if (payload.env) {
        setSurveyEnv({ env: payload.env.env, debug: payload.debug });
    }
    if (payload.siteRaw) {
        state.site = payload.siteRaw;
    }
    if (state.site.platformIdentifiers) {
        state.platformIdentifiersByKey = configurePlatformIdentifiers(state.site.platformIdentifiers);
    }
    return __assign(__assign({}, state), payload);
})
    .on(processForm, function (state, payload) {
    var _a;
    /// massage data for phone
    if (payload.fieldName === "phone") {
        var v = ((_a = payload.fieldValue) !== null && _a !== void 0 ? _a : "").replace(/\D/g, "");
        payload.fieldValue = formatPhone(v);
    }
    state.formAnswers[payload.fieldName] = payload.fieldValue;
    return __assign({}, state);
})
    .on(processQuestion, function (state, payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var q = state.currentQuestion;
    /// action of selected item
    var o = undefined;
    if (payload.index) {
        o = (_a = state.currentQuestion) === null || _a === void 0 ? void 0 : _a.options[payload.index];
    }
    //// no action - either next question, or FORM
    if (q.type === "PICK_MULTI" && !o) {
        //// if we're setting on a TQ DQ, and there is another TQ next, let it go through
        if (state.tqTargets && state.tqIndex < state.tqCount - 1) {
            state.tqIndex = state.tqIndex + 1;
            state.surveyTarget = state.tqTargets[state.tqIndex];
            state.currentSurvey = (_b = state.site.tortQualifySurvey) === null || _b === void 0 ? void 0 : _b.filter(function (tq, tqIdx) {
                return tq.id === state.surveyTarget;
            }).pop();
            state.currentSurveyQuestionIndex = 0;
            state.currentSurveyQuestionCount = state.currentSurvey.questions.length;
            state.currentQuestion = state.currentSurvey.questions[state.currentSurveyQuestionIndex];
            state.highMeter = doCalcMeter(state);
        }
        else if (state.currentSurveyQuestionIndex >= state.currentSurveyQuestionCount - 1) {
            if (state.surveyTarget !== "root") {
                state.qualifiesFor.push(state.currentSurvey.source);
            }
            state.state = SiteStoreState.FORM;
        }
        else {
            state.currentSurveyQuestionIndex = state.currentSurveyQuestionIndex + 1;
            state.currentQuestion = state.currentSurvey.questions[state.currentSurveyQuestionIndex];
            state.highMeter = doCalcMeter(state);
        }
    }
    else {
        /// DQ - either go to next TQ (if TQ), or show exit message
        if ((o === null || o === void 0 ? void 0 : o.action) === "DISQUALIFY") {
            /// PICK ONE
            if (q.type === "PICK_ONE") {
                if (state.surveyTarget === "root") {
                    state.quizNotificationReason = o.action;
                    state.quizNotificationText = (_c = o.actionText) !== null && _c !== void 0 ? _c : "DISQUALIFY TEXT";
                }
                else {
                    state.quizNotificationReason = o.action;
                    /// IN A TQ
                    /// IS THERE A NEXT TQ?
                    if (state.tqTargets && state.tqIndex < state.tqCount - 1) {
                        state.tqIndex = state.tqIndex + 1;
                        state.surveyTarget = state.tqTargets[state.tqIndex];
                        state.currentSurvey = (_d = state.site.tortQualifySurvey) === null || _d === void 0 ? void 0 : _d.filter(function (tq, tqIdx) {
                            return tq.id === state.surveyTarget;
                        }).pop();
                        state.currentSurveyQuestionIndex = 0;
                        state.currentSurveyQuestionCount = state.currentSurvey.questions.length;
                        state.currentQuestion = state.currentSurvey.questions[state.currentSurveyQuestionIndex];
                        state.highMeter = doCalcMeter(state);
                    }
                    else {
                        state.quizNotificationText = (_e = o.actionText) !== null && _e !== void 0 ? _e : "DISQUALIFY TEXT";
                    }
                }
            }
            /// PICK MULTI - DQ, get rid of others
            else {
                state.questionAnswers[q.token] = [o.value];
                state.quizNotificationReason = o.action;
                /// IN A TQ
                /// IS THERE A NEXT TQ?
                if (state.surveyTarget === "root" || state.tqIndex >= state.tqCount - 1) {
                    state.quizNotificationText = (_f = o.actionText) !== null && _f !== void 0 ? _f : "DISQUALIFY TEXT";
                }
            }
        }
        /// show educate message on current step
        else if ((o === null || o === void 0 ? void 0 : o.action) === "EDUCATE") {
            state.quizNotificationReason = o.action;
            state.quizNotificationText = (_g = o.actionText) !== null && _g !== void 0 ? _g : "EDUCATE TEXT";
        }
        //// switch to TQ survey
        //// no TORTQUALIFY on PICK_MULTI
        else if ((o === null || o === void 0 ? void 0 : o.action) === "TORTQUALIFY") {
            state.questionAnswers[q.token] = [o.value];
            state.tqTargets = o.tortQualifySurveyIds;
            state.tqIndex = 0;
            state.tqCount = state.tqTargets.length;
            state.surveyTarget = state.tqTargets[state.tqIndex];
            state.currentSurvey = (_h = state.site.tortQualifySurvey) === null || _h === void 0 ? void 0 : _h.filter(function (tq, tqIdx) {
                return tq.id === state.surveyTarget;
            }).pop();
            state.currentSurveyQuestionIndex = 0;
            state.currentSurveyQuestionCount = state.currentSurvey.questions.length;
            state.currentQuestion = state.currentSurvey.questions[state.currentSurveyQuestionIndex];
            state.highMeter = doCalcMeter(state);
        }
        //// no action - either next question, or FORM
        else {
            if ((o === null || o === void 0 ? void 0 : o.action) === "QUALIFY") {
                for (var _i = 0, _l = (_j = o === null || o === void 0 ? void 0 : o.qualifySource) !== null && _j !== void 0 ? _j : []; _i < _l.length; _i++) {
                    var qf = _l[_i];
                    state.qualifiesFor.push(qf);
                }
            }
            else if ((o === null || o === void 0 ? void 0 : o.action) === "DISQUALIFYFOR") {
                for (var _m = 0, _o = (_k = o === null || o === void 0 ? void 0 : o.disqualifySource) !== null && _k !== void 0 ? _k : []; _m < _o.length; _m++) {
                    var qf = _o[_m];
                    state.disqualifiesFor.push(qf);
                }
            }
            /// advance if a PICK_ONE
            if (q.type === "PICK_ONE") {
                /// stash answer
                state.questionAnswers[q.token] = [o.value];
                state.quizNotificationReason = "";
                state.quizNotificationText = "";
                if (state.currentSurveyQuestionIndex >= state.currentSurveyQuestionCount - 1) {
                    if (state.surveyTarget !== "root") {
                        state.qualifiesFor.push(state.currentSurvey.source);
                    }
                    state.state = SiteStoreState.FORM;
                }
                else {
                    state.currentSurveyQuestionIndex = state.currentSurveyQuestionIndex + 1;
                    state.currentQuestion = state.currentSurvey.questions[state.currentSurveyQuestionIndex];
                    state.highMeter = doCalcMeter(state);
                }
            }
            else {
                if (!state.questionAnswers[q.token]) {
                    state.questionAnswers[q.token] = [];
                }
                if (state.questionAnswers[q.token].includes(o.value)) {
                    // remove it
                    state.questionAnswers[q.token] = state.questionAnswers[q.token].filter(function (s) {
                        return s !== o.value;
                    });
                }
                else {
                    /// if the only thing selected are disqualifies, then remove them
                    if (state.quizNotificationReason !== "" && state.questionAnswers[q.token].length === 1) {
                        state.questionAnswers[q.token] = [];
                        state.quizNotificationReason = "";
                        state.quizNotificationText = "";
                    }
                    state.questionAnswers[q.token].push(o.value);
                }
            }
        }
    }
    return __assign({}, state);
});
